export default __webpack_public_path__ + "static/media/rm-white.86402018.svg";